<template>
  <base-ifp-filter
    label="Watching"
    optionless
    emphasize
    removable
    @close-clicked="handleCloseClick()"
  />
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'IfpFilterWatching',

  emits: ['only-watching-updated'],

  methods: {
    handleCloseClick() {
      this.$emit('only-watching-updated', false)
    },
  },
})
</script>
